import React from 'react';

import { WorkFeed } from '../components/WorkFeed/WorkFeed';
import { EngagementsTabNavigation } from '../components/EngagementsTabNavigation/EngagementsTabNavigation';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

export type WorkFeedPageProps = {
  name?: string;
};

export const WorkFeedPage = ({
  name = 'WORK_FEED_PAGE',
}: WorkFeedPageProps) => {
  useDocumentTitle('Work Feed');
  return (
    <div data-test={name}>
      <EngagementsTabNavigation
        startTab="OPPORTUNITY_FEED_TAB"
        pathToEngagements="../.."
      />
      <WorkFeed />
    </div>
  );
};
